var exports = {
  "I": "blankslate__oJtg3C",
};

module.exports = exports;
